import { render, staticRenderFns } from "./Notifications.htm?vue&type=template&id=7b94fa2b&"
import script from "./Notifications.ts?vue&type=script&lang=js&"
export * from "./Notifications.ts?vue&type=script&lang=js&"
import style0 from "./Notifications.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports